export const TRUST_TIERS = ['classic', 'approval', 'fraud'];
